<template>
  <div>
    <div class="DIV2">
      <span class="DIV4" v-show="dropdownObject.isMustInput">*</span>{{dropdownObject.label}}
    </div>
    <div class="DIV3">
      <el-dropdown split-button type="primary" @command="commandEvent">
        <span v-html="dropdownObject.dropdownTitle"></span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="(item,index) in dropdownObject.dropdownList" :key="index" :command="item.label">{{item.label}}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      dropdownObject:{
        //菜单内容
        type: Object
      },
    },
    data () {
      return {

      }
    },
    methods:{
      commandEvent(command) {
        this.dropdownObject.dropdownTitle = command
      }
    }
  }
</script>
<style scoped>
  @import '../../assets/common.css';
</style>



// WEBPACK FOOTER //
// src/components/Dropdown/index.vue